
import { getCookie, delCookie } from '@/util/util'
//获取最近的查询记录
const getNearbyWaybillNo = () => {
	let storageStr = localStorage.getItem('billNOs')
	let storageArr = storageStr ? storageStr.split(',') : []
	let cookieArr = getCookie('billNOs') ? decodeURIComponent(getCookie('billNOs')).split(',') : []
	return [...storageArr, ...cookieArr].uniq().slice(0, 6)
}
//更新最近查询记录
const setNearbyWaybillNo = arr => {
	localStorage.setItem('billNOs', [...arr, ...getNearbyWaybillNo()].uniq().slice(0, 6).join(','))
}
//删除最近查询记录
const deleteNearbyWaybillNo = () => {
	delCookie('billNOs')
	localStorage.setItem('billNOs', '')
}
export {
	getNearbyWaybillNo,
	setNearbyWaybillNo,
	deleteNearbyWaybillNo
}



// WEBPACK FOOTER //
// ./src/util/waybillUtils.js